
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Export = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect x="-0.3" y="-0.2" width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M17.9,15.8a2.3,2.3,0,0,1-2.3,2.3H4.9V5.2h6.5V3.7h-8V19.6H15.6a3.8,3.8,0,0,0,3.8-3.8V11.6H17.9Z"></path>
            <polygon points="13.6 2 13.6 3.5 18.5 3.5 10.9 11.1 11.9 12.2 19.6 4.6 19.6 9.4 21.1 9.4 21.1 2 13.6 2"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

Export.defaultProps = {
  title: 'Export',
};

export default Export;
